import axiosClient from './axiosClient';

export interface GetLogsPayload {
  tab?: 'admin' | 'backend' | string;
  module?: string;
  brandId?: string;
  locationId?: string;
  refId?: string;
  name?: string;
  action?: string;
  method?: string;
  level?: string;
  status?: number | string;
  userId?: string;
  adminUserId?: string;
  username?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  limit?: number;
  nextCursor?: string | null;
  isQuery?: boolean;
  query?: string;
}

const activitylogApi = {
  /** GET /activityHistory/getModules — list of available log module keys */
  getModules(): Promise<any> {
    return axiosClient.get('/activityHistory/getModules');
  },

  /** POST /activityHistory/getLogs — fetch CloudWatch logs for a module */
  getLogs(payload: GetLogsPayload): Promise<any> {
    const {
      tab,
      nextCursor,
      page,
      limit = 20,
      module = 'apiRequests',
      adminUserId,
      userId,
      status,
      ...rest
    } = payload;

    const data: Record<string, any> = {
      module,
      limit,
      ...(nextCursor ? { nextCursor } : { page: page || 1 }),
      userId: userId || adminUserId,
      ...(status !== undefined && status !== null && status !== '' ? { status: Number(status) } : {}),
      ...rest,
    };

    // Filter out undefined, null, and empty strings
    const cleanedPayload = Object.fromEntries(
      Object.entries(data).filter(([_, val]) => val !== undefined && val !== null && val !== '')
    );

    return axiosClient.post('/activityHistory/getLogs', cleanedPayload);
  },

  // Legacy alias kept so saga is not broken until slice is updated
  getActivityLogList(payload: any): Promise<any> {
    return activitylogApi.getLogs(payload);
  },
};

export default activitylogApi;

